import { ActionTree } from 'vuex';
import { StoreState } from '@/store/interfaces';

export const actions: ActionTree<StoreState, StoreState> = {
  async setPageLanguage({commit}, data) {
    const { lang, i18n } = data;
    i18n.locale = lang || localStorage.getItem('page_language') || 'pl';
    localStorage.setItem('page_language', i18n.locale);
    commit('set_page_language', i18n.locale);
  },
};
